import React from 'react'
import MissionVision from '../mission-vission'
import OurStrength from '../strength'

export default function AboutUs() {
  return (
    <div>
        <MissionVision/>
        <OurStrength/>
    </div>
  )
}
